import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Form, Table } from "react-bootstrap";
import { Buffer } from "buffer"
import { CreateDigest } from "../../routes/cryptography";

class Hash extends Component {
  constructor() {
    super();
    this.state = {

      belt_hash: "",
      bash512: "",
      bash384: "",
      bash256: "",
      isValidFileSize: true,
      fileIsOpen: false,
      filename: "файл",
      entityToHash: '',
      errors: {},
    };
    this.handleInputChangeData = this.handleInputChangeData.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleCleanChange = this.handleCleanChange.bind(this)
  }

  componentDidMount() {
    try {
      const algoritm = {
        belt_hash: "hbelt",
        bash512: "bash512",
        bash384: "bash384",
        bash256: "bash256",
      };
      if (document.getElementById("inputDataForHash").value.length === 0) {
        this.setState({ entityToHash: "пустая строка" });
        CreateDigest(Buffer.alloc(0), algoritm.bash256, "text").then((result) => {
          try {
            this.setState({
              bash256: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(Buffer.alloc(0), algoritm.bash384, "text").then((result) => {
          try {
            this.setState({
              bash384: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(Buffer.alloc(0), algoritm.bash512, "text").then((result) => {
          try {
            this.setState({
              bash512: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(Buffer.alloc(0), algoritm.belt_hash, "text").then((result) => {
          try {
            this.setState({
              belt_hash: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
      }
    } catch (error) {

    }
  }

  handleInputChangeData(e) {
    try {
      this.setState({ filename: "файл", fileIsOpen: false, entityToHash: "текст" });
      const algoritm = {
        belt_hash: "hbelt",
        bash512: "bash512",
        bash384: "bash384",
        bash256: "bash256",
      };

      if (e.target.value.length === 0) {
        document.getElementById("fileforhash").disabled = false;
        this.setState({
          entityToHash: "пустая строка",
          belt_hash: "",
          bash512: "",
          bash384: "",
          bash256: "",

        });
        CreateDigest(Buffer.alloc(0), algoritm.bash256, "text").then((result) => {
          try {
            this.setState({
              bash256: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(Buffer.alloc(0), algoritm.bash384, "text").then((result) => {
          try {
            this.setState({
              bash384: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(Buffer.alloc(0), algoritm.bash512, "text").then((result) => {
          try {
            this.setState({
              bash512: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(Buffer.alloc(0), algoritm.belt_hash, "text").then((result) => {
          try {
            this.setState({
              belt_hash: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
      } else {
        CreateDigest(e.target.value, algoritm.bash256, "text").then((result) => {
          try {
            this.setState({
              bash256: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(e.target.value, algoritm.bash384, "text").then((result) => {
          try {
            this.setState({
              bash384: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(e.target.value, algoritm.bash512, "text").then((result) => {
          try {
            this.setState({
              bash512: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(e.target.value, algoritm.belt_hash, "text").then((result) => {
          try {
            this.setState({
              belt_hash: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
            });
          } catch (error) {
            console.log(error);
          }
        });
        document.getElementById("fileforhash").disabled = true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  handleFileChange(e) {
    try {

      const file = e.target.files[0];
      if (file !== undefined && file.size <= 5000000) {
        document.getElementById("inputDataForHash").disabled = true;

        this.setState({
          filename: file.name, fileIsOpen: true, entityToHash: "файл", isValidFileSize: true,
        });
        const algoritm = {
          belt_hash: "belt-hash",
          bash512: "bash512",
          bash384: "bash384",
          bash256: "bash256",
        };

        CreateDigest(file, algoritm.bash256, "file").then((result) => {
          try {
            this.setState({
              bash256: Buffer.from(result.data.hash, "base64")
                .toString("hex")
                .toUpperCase(),
            });
            //console.log(result);
          } catch (error) {
            console.log(error);
          }
        });
        CreateDigest(file, algoritm.bash384, "file").then((result) => {
          try {
            this.setState({
              bash384: Buffer.from(result.data.hash, "base64")
                .toString("hex")
                .toUpperCase(),
            });
          } catch (error) {
            //console.log(error);
          }
        });
        CreateDigest(file, algoritm.bash512, "file").then((result) => {
          try {
            this.setState({
              bash512: Buffer.from(result.data.hash, "base64")
                .toString("hex")
                .toUpperCase(),
            });
          } catch (error) {
            //console.log(error);
          }
        });
        CreateDigest(file, algoritm.belt_hash, "file").then((result) => {
          try {
            this.setState({
              belt_hash: Buffer.from(result.data.hash, "base64")
                .toString("hex")
                .toUpperCase(),
            });
          } catch (error) {
            //console.log(error);
          }
        });
    
      } else if (file === undefined) {
        this.handleCleanChange()
      } else if (file.size > 5000000) {
        this.setState({
          isValidFileSize: false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  handleCleanChange() {
    try {

      const algoritm = {
        belt_hash: "hbelt",
        bash512: "bash512",
        bash384: "bash384",
        bash256: "bash256",
      };

      document.getElementById("fileforhash").disabled = false;
      document.getElementById("inputDataForHash").disabled = false;
      document.getElementById("inputDataForHash").value = '';
      this.setState({ entityToHash: "пустая строка" });
      CreateDigest(Buffer.alloc(0), algoritm.bash256, "text").then((result) => {
        try {
          this.setState({
            bash256: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
          });
        } catch (error) {
          console.log(error);
        }
      });
      CreateDigest(Buffer.alloc(0), algoritm.bash384, "text").then((result) => {
        try {
          this.setState({
            bash384: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
          });
        } catch (error) {
          console.log(error);
        }
      });
      CreateDigest(Buffer.alloc(0), algoritm.bash512, "text").then((result) => {
        try {
          this.setState({
            bash512: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
          });
        } catch (error) {
          console.log(error);
        }
      });
      CreateDigest(Buffer.alloc(0), algoritm.belt_hash, "text").then((result) => {
        try {
          this.setState({
            belt_hash: Buffer.from(result.data.hash, "base64").toString("hex").toUpperCase(),
          });
        } catch (error) {
          console.log(error);
        }
      });
      this.setState({

        belt_hash: "",
        bash512: "",
        bash384: "",
        bash256: "",

        fileIsOpen: false,
        isValidFileSize: true,
        filename: "файл",
      })
    } catch (error) {
      console.log(error);

    }
  }

  render() {
    return (
      <div className="">
        <div>
          <h4 className="major">Хэширование</h4>

        </div>
        <Form style={{ marginBottom: "0" }}>
          <div className="sm-4">
            <div className="row">
              <div className="col-lg">
                <Form.Group>
                  <Form.Label>Введите текст</Form.Label>
                  <Form.Control
                    type="text"
                    id="inputDataForHash"
                    placeholder="Текст"
                    onChange={this.handleInputChangeData}
                    style={{ height: "2rem", color: "white" }}
                  />
                </Form.Group>
              </div>
              <div className="block-and" >
                <Form.Label >или</Form.Label>

              </div>
              <div className="col-lg">
                <Form.Group>
                  <Form.Label>Выберите файл</Form.Label>
                  <Form.File custom>
                    <Form.File.Input
                      id="fileforhash"
                      onChange={this.handleFileChange}
                      isValid={this.state.fileIsOpen}
                      isInvalid={!this.state.isValidFileSize}
                    />
                    <Form.File.Label data-browse="Выбрать">
                      {this.state.filename}
                    </Form.File.Label>
                    <Form.Control.Feedback type="valid" />
                    <Form.Control.Feedback type="invalid">
                      максимальный размер файла 5мб
                    </Form.Control.Feedback>
                  </Form.File>
                </Form.Group>
              </div>
            </div>
          </div>
          <span>
            <Button
              type="button"
              onClick={this.handleCleanChange}
              style={{ height: "30px", float: "right", fontSize: "11px" }}>
              Очистить
            </Button>
          </span>
        </Form>

        <Table
          style={{
            maxWidth: "100%",
            minWidth: "auto",
            maxHeight: "100%",
            minHeight: "auto",
            fontSize: "70%",
            color: "white"
          }}
        >
          <thead>
            <tr style={{
              fontSize: "130%",
            }}>
              <th>Алгоритм</th>
              <th>Результат &nbsp;
                {this.state.entityToHash === "" && this.state.entityToHash}
                {this.state.entityToHash === "текст" && `(${this.state.entityToHash})`}
                {this.state.entityToHash === "файл" && `(${this.state.entityToHash})`}
                {this.state.entityToHash === "пустая строка" && `(${this.state.entityToHash})`}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="alg">bash256(СТБ 34.101.77 l=128)</td>
              <td>{this.state.bash256}</td>
            </tr>
            <tr>
              <td className="alg">bash384(СТБ 34.101.77 l=192)</td>
              <td>{this.state.bash384}</td>
            </tr>
            <tr>
              <td className="alg">bash512(СТБ 34.101.77 l=256)</td>
              <td>{this.state.bash512}</td>
            </tr>
            <tr>
              <td className="alg">belt-hash(СТБ 34.101.31 п.6.9)</td>
              <td>{this.state.belt_hash}</td>
            </tr>
          </tbody>
        </Table>

      </div>
    );
  }
}
export default connect()(withRouter(Hash));
